<template>
  <div>
    <SearchComponent
      :isAdd="true"
      :selectOrInputList="selectOrInputList"
      @on-date="handleDateChange"
      @on-search="handleSearch"
      @on-reset="handleReset"
      @on-add="handleAdd"
      :authIdentity="authIdentity"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :paginationFlag="true"
      :total="total"
      :pageParams="queryParams"
      @pageChange="getList"
    >
      <template slot="solts" slot-scope="scope">
        <el-button
          @click="handleEdit(scope.data, '编辑')"
          type="text"
          size="small"
          class="button"
          v-hasPermi="[authIdentity + ':edit']"
        >修改</el-button>

        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          class="button"
          type="text"
          size="small"
          @click="handleView(scope.data, '查看')"
        >详情</el-button>

        <el-button
          v-hasPermi="[authIdentity + ':del']"
          class="delbutton"
          type="text"
          size="small"
          @click="handleDel(scope.data, '删除')"
        >删除</el-button>

        <el-button
          v-hasPermi="[authIdentity + ':task']"
          :disabled="scope.data.notTask && scope.data.redistributionStatus != 1"
          class="button"
          type="text"
          size="small"
          @click="checkTask(scope.data, '任务')"
        >派发走访任务</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':record']"
          class="button"
          type="text"
          size="small"
          @click="handleRecord(scope.data, scope.$index)"
        >走访记录</el-button>
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component v-if="dialogVisible" :ref="currentView" :is="currentView" :type="type"></component>
      <span slot="footer" v-if="type != 'preview'">
        <el-button :disabled="loading" class="batch-button" @click="cancel">取 消</el-button>
        <el-button :loading="loading" class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/statusConstants'
import { mapState, mapActions } from 'vuex'
import { getPlantList, delPlantation, getSelectPlantationArea, checkPlantationTask, getSettingByKey } from '@/api/system/manage'
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import myform from '@/views/detail/manage/components/form'
import task from '@/views/detail/interview/components/form' //派发任务
import Detail from '@/views/detail/manage/components/detail' //查看详情
import { dateHourCompute } from '@/utils/common'

export default {
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
    task,
    Detail,
  },
  data() {
    const _this = this
    return {
      type: '',
      loading: false,
      queryParams: {},
      authIdentity: 'detail:manage',
      dialogVisible: false,
      title: '',
      currentView: '',
      colLists: [
        {
          prop: 'bizNo',
          label: '果园编号',
          isTrue: true,
          width: 80,
        },
        {
          prop: 'name',
          label: '果园名称',
          isTrue: true,
          align: 'left'
        },
        {
          prop: 'cropBrandKey',
          label: '产品名称',
          isTrue: true,
          width: 80,
          formatter(row) {
            return _this.formatDictToText(row.cropBrandKey, 'productType', _this.dictList)
          },
        },
        {
          prop: 'locDetails',
          label: '果园区域',
          isTrue: true,
          align: 'left',
          formatter(row) {
            return _this.formatLocal(row.locDetails, 3)
          },
        },
        {
          prop: 'ownerName',
          label: '园长/场长',
          isTrue: true,
          align: 'left',
          width: 90,
        },
        {
          prop: 'ownerContact',
          label: '联系方式',
          isTrue: true,
        },
        {
          prop: 'lastVisitTime',
          label: '最新走访日期',
          isTrue: true,
          formatter(row) {
            return _this.parseTime(row.lastVisitTime, '{y}-{m}-{d}')
          },
        },
        {
          prop: 'readyForHarvestStatus',
          label: '采摘要求是否达标',
          isTrue: true,
          width: 140,
          formatter(row) {
            return CONSTANTS.getStatusConversionForYear(
              row.readyForHarvestStatus,
              'readyForHarvestStatus',
              row.lastVisitTime
            )
          },
        },
        {
          prop: 'pesticideTestPassedStatus',
          label: '农残',
          isTrue: true,
          formatter(row) {
            return CONSTANTS.getStatusConversionForYear(
              row.pesticideTestPassedStatus,
              'pesticideTestPassedStatus',
              row.testDateTime
            )
          },
        },
        {
          prop: 'heavyMetalTestPassedStatus',
          label: '重金属',
          isTrue: true,
          width: 110,
          formatter(row) {
            return CONSTANTS.getStatusConversionForYear(
              row.heavyMetalTestPassedStatus,
              'heavyMetalTestPassedStatus',
              row.testDateTime
            )
          },
        },
        {
          prop: 'lastAssignedVisitTaskTime',
          label: '派发任务日期',
          isTrue: true,
          width: 110,
          formatter(row) {
            return _this.parseTime(row.lastAssignedVisitTaskTime, '{y}-{m}-{d}')
          },
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 320,
          rightFlag: true,
        },
      ],
      total: 0,
      tableData: [],
      localList: [],
      selectOrInputList: [
        {
          model: 'locIndex',
          placeholder: '请选择区域',
          label: 'locName',
          value: 'locIndex',
          list: [],
          type: 'select',
        },
        {
          model: 'codeOrBizNo',
          placeholder: '请输入果园编号或名称',
          class: 'home',
          type: 'input',
        },
        {
          model: 'visitTime',
          placeholder: '请选择走访年份',
          class: 'home',
          type: 'year',
        },
        {
          model: 'readyForHarvestStatus',
          placeholder: '请选择采摘要求是否达标',
          value: 'value',
          label: 'label',
          list: CONSTANTS.readyForHarvestStatus,
          type: 'select',
        },
        {
          model: 'testDateTime',
          placeholder: '请选择农残检测年份',
          class: 'home',
          type: 'year',
        },
        {
          model: 'pesticideTestPassedStatus',
          placeholder: '请选择农残结果',
          value: 'value',
          label: 'label',
          list: CONSTANTS.pesticideTestPassedStatus,
          type: 'select',
        },
        {
          model: 'heavyMetalTestPassedStatus',
          placeholder: '请选择重金属结果',
          value: 'value',
          label: 'label',
          list: CONSTANTS.heavyMetalTestPassedStatus,
          type: 'select',
        },
      ],
      refreshDay: 0
    }
  },
  async created() {
    this.getDictList({ types: 'landStatus,productType,fertilizerType', productName: '柑果' })
    this.getSelectPlantationAreaList()
    this.getSettingDay()
  },
  mounted(){
    this.getList()
  },
  computed: {
    ...mapState({
      dictList: (state) => state.system.dictList || [],
    }),
  },
  methods: {
    ...mapActions({ getDictList: 'system/getDictList' }),
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getPlantList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              if(item.lastAssignedVisitTaskTime){
                const expireHour = Number(this.refreshDay)*24
                const date = this.parseTime(item.lastAssignedVisitTaskTime, '{y}-{m}-{d}')
                const expireDateObj = dateHourCompute(date, expireHour)
                const expireDate = expireDateObj.y+'-'+expireDateObj.m+'-'+expireDateObj.d
                const currentTime = new Date().getTime()
                const expireTime = new Date(expireDate).getTime()
                // const currentTime = new Date().getTime()
                // const expireTime = new Date(item.lastAssignedVisitTaskTime).getTime() + (3*60*1000)
                item.notTask = currentTime < expireTime ? true : false
              }
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async getSelectPlantationAreaList() {
      let res = await getSelectPlantationArea()
      if (res.flag) {
        this.localList = res.data
        this.selectOrInputList[0].list = res.data.map((item, index) => {
          item.locIndex = index + 1
          item.locName = this.formatLocal(item.locDetails, 3)
          return item
        })
      }
    },
    async getSettingDay(){
      let res = await getSettingByKey({
        code: 'visitTaskRefreshTime'
      })
      if (res.flag) {
        this.refreshDay = res.data.value
      }
    },
    submitFrom() {
      this.loading = true
      this.$refs[this.currentView]
        .submit()
        .then(() => {
          this.loading = false
          this.cancel()
          this.getSelectPlantationAreaList()
          this.getList()
        })
        .catch(() => {
          this.loading = false
        })
    },
    cancel() {
      if (this.loading) {
        return
      }
      this.dialogVisible = false
    },
    handleDel(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          delPlantation(row.id).then((response) => {
            if (response.code == 200 && response.flag) {
              this.$message.success(`删除成功！`)
              this.getSelectPlantationAreaList()
              this.getList()
            } else {
              this.$message.warning(response.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    handleRecord(row) {
      this.$store.commit('manage/SET_INFO_DETAIL', row)
      this.$router.push({ path: '/record' })
    },
    handleAdd() {
      this.type = 'add'
      this.title = '新增果园'
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        this.$refs[this.currentView].initArea()
      })
    },
    handleEdit(row) {
      this.type = 'edit'
      this.title = '编辑果园'
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    checkTask(row){
      checkPlantationTask({
        id: row.id
      }).then((response) => {
        if(!response.data){
          this.$message.warning(`还未到派发时间，一个月仅支持派发一次`)
        }else{
          this.handleTask(row)
        }
      })
    },
    handleTask(row) {
      this.type = 'add'
      this.title = '派发任务'
      this.dialogVisible = true
      this.currentView = 'task'
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    handleDateChange(query) {
      this.selectOrInputList[3].list =
        query && query.visitTime ? CONSTANTS.readyForHarvestStatus1 : CONSTANTS.readyForHarvestStatus
      this.selectOrInputList[5].list =
        query && query.testDateTime ? CONSTANTS.pesticideTestPassedStatus1 : CONSTANTS.pesticideTestPassedStatus
      this.selectOrInputList[6].list =
        query && query.testDateTime ? CONSTANTS.heavyMetalTestPassedStatus1 : CONSTANTS.heavyMetalTestPassedStatus
    },
    handleSearch(query) {
      if (query.locIndex) {
        query.streetCode = this.localList[query.locIndex - 1].streetCode
        query.villageCode = this.localList[query.locIndex - 1].villageCode
        query.fieldCode = this.localList[query.locIndex - 1].fieldCode
      } else {
        delete query.fieldCode
        delete query.streetCode
        delete query.villageCode
        delete this.queryParams.fieldCode
        delete this.queryParams.streetCode
        delete this.queryParams.villageCode
      }
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
      }
      this.handleDateChange()
      this.getList()
    },
    handleView(row) {
      this.type = 'preview'
      this.title = '查看果园'
      this.dialogVisible = true
      this.currentView = 'Detail'
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
  },
}
</script>

<style scoped lang='less'>
@import '~@/assets/tableList.less';

/deep/ .delbutton.el-button--text {
  color: red;
}
</style>